
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
	standalone: true,
	selector: 'footer',
	templateUrl: './footer.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [RouterModule]
})

export class FooterComponent {

	year: number = new Date().getFullYear();
	constructor(
		private router: RouterModule
	) {

	}
}
